module.exports = __webpack_public_path__ + "img/Access Manager.823a39f5.svg";